import React from "react";
import { Link } from "react-router-dom";
import { Cpu, ArrowRight } from "lucide-react";

// Cross-link to Edge Compute from spectral/terrain pages — keeps the Jetson pipeline one tap away.
export const EdgeLinkCard = ({ tab = "lab", text, tr }) => (
  <Link to={`/edge?tab=${tab}`} data-testid="edge-link-card" className="qs-panel p-3 flex items-center gap-3 border border-[#00FFFF]/20 hover:border-[#00FFFF]/60 transition-colors group">
    <Cpu className="h-5 w-5 text-[#00FFFF] shrink-0" />
    <div className="flex-1 min-w-0"><p className="text-[10px] uppercase tracking-widest text-[#00FFFF]">Edge Compute · Jetson</p><p className="text-xs text-slate-300">{text || (tr ? "Pushbroom hat taramalarını DEM üzerinde gerçek zamanlı ortorektifiye edin (CUDA doku belleği)." : "Orthorectify pushbroom line scans against the DEM in real time (CUDA texture memory).")}</p></div>
    <ArrowRight className="h-4 w-4 text-slate-500 group-hover:text-[#00FFFF]" />
  </Link>
);
